import { useCallback } from "react";

interface Result {
  duration: number;
}

const useCaptureVideoInfo = () => {
  const captureVideoInfo = useCallback(
    (url) =>
      // eslint-disable-next-line compat/compat
      new Promise<Result>((resolve, reject) => {
        const video = document.createElement("video");
        video.setAttribute("src", `${url}#t=5,6`);
        video.setAttribute("preload", "metadata");
        video.setAttribute("crossorigin", "anonymous");
        video.setAttribute("playsinline", "true");
        if (video) {
          video.onloadeddata = () => {
            resolve({
              duration: video?.duration ?? 0,
            });
          };

          video.onerror = () => {
            reject(new Error("capture image failed"));
          };
        } else {
          reject(new Error("capture image failed"));
        }
      }),
    []
  );

  return captureVideoInfo;
};

export default useCaptureVideoInfo;
